import { PUBLIC_ROUTES } from './public';
import { PRIVATE_ROUTES } from './private';

export { PUBLIC_ROUTES, PRIVATE_ROUTES };
